import useImageLoader from 'shared/hooks/useImageLoader';
import { ProfileImageHolderContainer, ProfileImageHolderImage } from './ProfileImageHolder.styles';
import AvatarSkeleton from 'components/Avatar/AvatarSkeleton/AvatarSkeleton';
const ProfileImageHolder = ({ picture }: { picture: string }) => {
  const { imageLoaded, noProfileImage, error } = useImageLoader(picture);
  return (
    <ProfileImageHolderContainer height={160}>
      {imageLoaded ? (
        <ProfileImageHolderImage src={imageLoaded && !error ? picture : noProfileImage} alt="Profile Image" />
      ) : (
        <AvatarSkeleton style={{ width: '100%', height: '100%', border: 'none' }} />
      )}
    </ProfileImageHolderContainer>
  );
};

export default ProfileImageHolder;
